import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { isServer } from './utils';
export var DocumentContext = createContext(isServer ? undefined : document);
DocumentContext.displayName = 'DocumentContext';
export var DocumentProvider = function (props) {
    var documentValue = useMemo(function () {
        if (!isServer) {
            return props.value || document;
        }
        return undefined;
    }, []);
    return _jsx(DocumentContext.Provider, __assign({ value: documentValue }, { children: props.children }), void 0);
};
DocumentProvider.displayName = 'DocumentProvider';
export var useDocument = function () { return useContext(DocumentContext); };
